import React from 'react';

const Privacy = () => {
  return (
    <div className="privacy">
      <h1>Privacy Policy</h1>
      <p>At Alert, we are committed to protecting your privacy. Any data you share with us is kept secure and is only used for the purpose of enhancing your experience on our platform.</p>
      <p>Your data will not be shared with third parties without your consent, and all personal information is stored securely. We continuously work to ensure your privacy and the security of your data.</p>
    </div>
  );
};

export default Privacy;